<template>
  <div class="chart">
    <div class="chart__info">
      <div class="chart__detail">
        The CC Lab’s risk-adjusted goal is
        <div class="rate">{{ total_impact }}M</div>
        metric tons CO<sub>2</sub>e contained by {{ nearterm_end_year }}
      </div>
      <div class="chart__detail">
        Equivalent to <span v-html="impact_data.equivalent_to"></span>
        <div class="rate" v-if="impact_data.type !== 'pie'">{{ impact_data.impact }}M</div>
        <div class="rate" v-else>{{impact_data.impact}}%</div>
        {{ impact_data.equivalent_metric ? impact_data.equivalent_metric : ''}}
      </div>

      <div v-if="impact_data.legend_rate" class="chart__legend">
        <svg-vue :icon=impact_data.icon></svg-vue>
        <span>= {{ adjustedImpact.keyMultipler }} {{ impact_data.legend_rate}}</span>
      </div>
    </div>
    
    <div v-if="impact_data.type !== 'pie'" class="chart__wrapper">
      <svg-vue :icon=impact_data.icon v-for="n in adjustedImpact.graphImpact"></svg-vue>
    </div>

    <div v-else class="chart__pie-chart">
      <Pie :value=impact_data.impact />
    </div>
  </div>

</template>


<script>

import Pie from './Pie.vue'

export default {
  name: "EquivalencyInfoChart",
  props: ['impact_data', 'total_impact', 'nearterm_end_year'],
  components: {Pie},
  computed: {
    adjustedImpact() {
      if (this.$props.impact_data.impact < 10) {
        const adjustedImpactValue = Math.floor(this.$props.impact_data.impact * 20);
        return {
          keyMultipler: '20,000',
          graphImpact: adjustedImpactValue
        }
      } else if (this.$props.impact_data.impact > 100) {
        const adjustedImpactValue = Math.floor(this.$props.impact_data.impact / 10);
        return {
          keyMultipler: '10 million',
          graphImpact: adjustedImpactValue
        }
      } else {
        return {
          keyMultipler: '1 million',
          graphImpact: Math.floor(this.$props.impact_data.impact)
        }
      }
    }
  }
};
</script>